// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header__logo":"Header_header__logo__rOZQD","logo":"Header_logo__shVBB"};